// Shared side-column mapping — single source of truth for the load/unload
// axis of the `transactions` table.
//
// Lives in `shared/` (not `src/utility/`) so both the FE helper and the
// edge-fn / class-based services can read the same map without crossing
// tree boundaries. Drift between the two used to be the documented risk
// (see `src/CLAUDE.md` "Transaction side-aware code: …Mirror exists in
// the edge-function runtime; drift breaks load/unload sync.").
//
// Note: `unloaded_weight` is the canonical column for BOTH sides; the
// `loaded_weight` column is deprecated.

import type { PricingSide } from './types.ts';

export interface SideColumnNames {
  price:             'load_price'                 | 'unload_price';
  currency:          'load_price_currency'        | 'unload_price_currency';
  priceType:         'load_price_type'            | 'unload_price_type';
  vatRateCode:       'load_price_vat_rate_code'   | 'unload_price_vat_rate_code';
  incoterms:         'load_price_incoterms'       | 'unload_price_incoterms';
  priceListId:       'load_price_list_id'         | 'unload_price_list_id';
  companyId:         'load_commercial_company_id' | 'unload_commercial_company_id';
  locationCompanyId: 'load_place_company_id'      | 'unload_place_company_id';
  date:              'load_date'                  | 'unload_date';
  weight:            'unloaded_weight';
  salesEmployeeId:   'load_sales_employee_id'     | 'unload_sales_employee_id';
  invoicedStatus:    'load_invoiced_status'       | 'unload_invoiced_status';
}

export const SIDE_COLUMNS: Record<PricingSide, SideColumnNames> = {
  load: {
    price:             'load_price',
    currency:          'load_price_currency',
    priceType:         'load_price_type',
    vatRateCode:       'load_price_vat_rate_code',
    incoterms:         'load_price_incoterms',
    priceListId:       'load_price_list_id',
    companyId:         'load_commercial_company_id',
    locationCompanyId: 'load_place_company_id',
    date:              'load_date',
    weight:            'unloaded_weight',
    salesEmployeeId:   'load_sales_employee_id',
    invoicedStatus:    'load_invoiced_status',
  },
  unload: {
    price:             'unload_price',
    currency:          'unload_price_currency',
    priceType:         'unload_price_type',
    vatRateCode:       'unload_price_vat_rate_code',
    incoterms:         'unload_price_incoterms',
    priceListId:       'unload_price_list_id',
    companyId:         'unload_commercial_company_id',
    locationCompanyId: 'unload_place_company_id',
    date:              'unload_date',
    weight:            'unloaded_weight',
    salesEmployeeId:   'unload_sales_employee_id',
    invoicedStatus:    'unload_invoiced_status',
  },
};

export function getSideColumnNames(side: PricingSide): SideColumnNames {
  return SIDE_COLUMNS[side];
}
